import { forwardRef, type Ref, type ReactNode, type HTMLAttributes } from 'react';
import { useAppShell } from './AppShellContext.js';

export interface AppShellNavbarProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  withBorder?: boolean;
}

/**
 * Side rail. Width adapts to `AppShell.navbarMode`:
 * `icon` → narrow / `compact` → narrow + tiny label below / `full` → wide.
 */
export const AppShellNavbar = forwardRef(function AppShellNavbar(
  { children, withBorder = true, className, ...rest }: AppShellNavbarProps,
  ref: Ref<HTMLElement>
): ReactNode {
  const { navbarMode } = useAppShell();
  return (
    <nav
      ref={ref}
      data-navbar-mode={navbarMode}
      aria-label="Primary"
      className={[
        'rr-app-shell__navbar',
        `rr-app-shell__navbar--${navbarMode}`,
        withBorder && 'rr-app-shell__navbar--bordered',
        className
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </nav>
  );
});
AppShellNavbar.displayName = 'AppShellNavbar';
